import { render, staticRenderFns } from "./MoreContent.vue?vue&type=template&id=63b4477a"
import script from "./MoreContent.vue?vue&type=script&lang=js"
export * from "./MoreContent.vue?vue&type=script&lang=js"
import style0 from "./MoreContent.vue?vue&type=style&index=0&id=63b4477a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0___96a47b7faf05f8ec6a90f2e68e8aca99/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports